import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import config from "../config";
import { getCurrentUser } from "@aws-amplify/auth";
import { Hub } from "aws-amplify/utils";
import { AmplifyEventBus } from "aws-amplify-vue";
import { signOut } from "../modules/auth";
import VpdEventBus from "../modules/vpd-event-bus";
import Accounts from "../views/Accounts.vue";
import Calculation from "../views/Calculation.vue";
import ServicesTermsAndConditions from "../views/ServicesTermsAndConditions.vue";
import Login from "../views/Login.vue";
import ConfirmOtp from "../views/ConfirmOtp.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import ComplaintPolicy from "../views/ComplaintPolicy.vue";
import Callback from "../views/Callback.vue";
import Page404 from "../views/404.vue";
import CookiePolicy from "../views/CookiePolicy.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home,
    name: "home",
    props: { config },
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "defaultPath",
        redirect: "accounts",
        props: { config },
      },
      {
        path: "accounts",
        name: "accounts",
        component: Accounts,
        props: { config },
        meta: { requiresAuth: true },
      }
    ],
  },
  {
    path: "/oauth/callback/:bank",
    name: "oauth-handler",
    component: Callback,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      to.meta.props = {
        to: to,
      };
      next();
    },
  },
  {
    path: "/services-terms-and-conditions",
    name: "services-terms-and-conditions",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ServicesTermsAndConditions,
    props: { config },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    props: { config },
    meta: { authEntry: true },
  },
  {
    path: "/logout",
    name: "logout",
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      await signOut();
      next({ name: "home" });
    },
  },
  {
    path: "/confirm-otp",
    name: "confirmOtp",
    component: ConfirmOtp,
    props: { config },
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: PrivacyPolicy,
    props: { config },
  },
  {
    path: "/cookie-policy",
    name: "cookie-policy",
    component: CookiePolicy,
    props: { config },
  },
  {
    path: "/complaint-policy",
    name: "complaint-policy",
    component: ComplaintPolicy,
    props: { config },
  },
  /*{
      path: "/ws",
      name: "ws",
      component: () => import("../views/WsTest.vue"),
      props: { config },
      meta: { requiresAuth: true },
    },*/
  {
    path: "*",
    name: "404",
    component: Page404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior() {
    document.getElementById('app').scrollIntoView({ behavior: 'auto' });
  }
});

function pushIfNotSame(to) {
  const target = router.resolve(to).route.fullPath;
  if (router.currentRoute.fullPath !== target) {
    return router.push(to).catch(err => {
      if (!err || err.name !== 'NavigationDuplicated') throw err;
    });
  }
}

const redirects = {
  signIn: () => pushIfNotSame({ name: 'login' }),
  confirmOtp: () => pushIfNotSame({ name: 'confirmOtp' }),
  // signedIn: () => {
  //   const path = '/';
  //   pushIfNotSame({ path });
  // },
};

AmplifyEventBus.$on("authState", async (state) => {
  if (typeof redirects[state] === "function") {
    router.app.$store.dispatch("general/userState", state);
    redirects[state]();
  }
});

VpdEventBus.$on("redirect", async (data) => {
  const entry = `redirect_${data.name}`;
  if (typeof redirects[entry] === "function") {
    redirects[entry](data.payload);
  }
});

Hub.listen("auth", (data) => {
  const state = data.payload.event;

  switch (state) {
    case "signIn":
      break;
    case "signIn_failure":
      break;
    case "tokenRefresh_failure":
      break;
    default:
      break;
  }
});

// router.beforeEach(async (to, from, next) => {
//   await redirectToOriginSubdomain();
//   next();
// });

router.beforeResolve(async (to, from, next) => {
  try {
    if (!to.matched.some(r => r.meta.requiresAuth)) return next();

    const pendingUser = localStorage.getItem('pendingUser');
    if (pendingUser) return next(); // OTP flow skips auth check


    const user = await getCurrentUser();
    if (user && user.signInUserSession) {
      router.app.$store.dispatch('general/userState', 'signedIn');
    }
    return next();
  } catch {
    return next({ name: 'login', query: { redirect: to.fullPath } });
  }
});

export default router;
